import { useEffect, useState } from "react";

const HeroHeader = ({
  title,
  highlight,
  subtitle,
  backgroundImage,
  height = "60vh",
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <div
      className="relative overflow-hidden bg-center  bg-cover md:bg-fixed"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        height,
      }}
    >
      
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50" />

      {/* Content */}
      <div className="relative flex items-center justify-center h-full px-6">
        <div
          className={`text-center max-w-4xl transition-all duration-1000 transform
          ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`}
        >
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl md:text-6xl">
            {title}{" "}
            {highlight && (
              <span className="text-[#ffffff]">{highlight}</span>
            )}
          </h1>

          {subtitle && (
            <p className="mt-6 text-lg leading-8 text-gray-200">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default HeroHeader;
